import { Component } from '@angular/core';

import {SubtitlesService} from "../../../core";

@Component({
    selector: 'tile-error',
    templateUrl: './tile-error.component.html',
    styleUrls: ['./tile-error.component.scss']
})
export class TileErrorComponent {
    constructor(
        private subtitles: SubtitlesService,
    ) {
    }

    subtitle(val: number): string {
        return this.subtitles.setSubtitle(val);
    }
}
